import { render, staticRenderFns } from "./VueNumberFormat.vue?vue&type=template&id=125cc27c&"
import script from "./VueNumberFormat.vue?vue&type=script&lang=js&"
export * from "./VueNumberFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports